module.exports = __webpack_public_path__ + "img/icon-tick.7a438cb0.svg";